/**
 * TrendModa — Ürün Kartı Sepete Ekle (AJAX)
 * Koleksiyon / anasayfa ürün kartlarındaki "Sepete Ekle" butonunu yönetir.
 */
(function () {
  'use strict';
  if (window.TrendModaCardATC) return;
  window.TrendModaCardATC = true;

  function addToCart(variantId, btn) {
    if (btn.dataset.busy === 'true') return;
    btn.dataset.busy = 'true';

    var originalHTML = btn.innerHTML;
    btn.classList.add('ty-card__atc--loading');
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation:spin .7s linear infinite"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".25"/><path d="M21 12a9 9 0 0 0-9-9"/></svg> Ekleniyor…';

    var isDesktop = window.innerWidth >= 990;

    // Cart drawer — sadece mobilde kullan
    var cartDrawer = !isDesktop ? (document.querySelector('cart-drawer') || document.querySelector('#cart-drawer')) : null;
    var sectionsParam = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsParam = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }

    var payload = {
      id: parseInt(variantId, 10),
      quantity: 1
    };
    if (sectionsParam.length > 0) {
      payload.sections = sectionsParam;
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Ürün eklenemedi');
        }

        // Masaüstü: direkt sepet sayfasına git
        if (isDesktop) {
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
          return;
        }

        // Mobil: başarı durumu göster
        btn.classList.remove('ty-card__atc--loading');
        btn.classList.add('ty-card__atc--success');
        btn.innerHTML =
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Sepete Eklendi!';

        updateCartCount(1);

        // Mobil: Cart drawer güncelle ve aç
        if (cartDrawer) {
          if (data.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-atc',
            productVariantId: String(variantId),
            cartData: data,
          });
        }
      })
      .catch(function (err) {
        console.error('[card-atc]', err);
        btn.classList.remove('ty-card__atc--loading');
        btn.classList.add('ty-card__atc--error');
        btn.innerHTML = 'Hata — Tekrar Dene';
      })
      .finally(function () {
        setTimeout(function () {
          btn.dataset.busy = 'false';
          btn.classList.remove('ty-card__atc--loading', 'ty-card__atc--success', 'ty-card__atc--error');
          btn.innerHTML = originalHTML;
        }, 2500);
      });
  }

  function updateCartCount(added) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ty-header__cart-count, #cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  // Beden seçici — tıklanan bedeni seç ve variant id'yi güncelle
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.ty-card__size:not(.ty-card__size--disabled)');
    if (!sizeBtn) return;
    e.preventDefault();
    var sizesWrap = sizeBtn.closest('.ty-card__sizes');
    if (sizesWrap) {
      sizesWrap.querySelectorAll('.ty-card__size').forEach(function (b) {
        b.classList.remove('ty-card__size--selected');
      });
    }
    sizeBtn.classList.add('ty-card__size--selected');
    var card = sizeBtn.closest('.ty-card');
    if (card) {
      var atcBtn = card.querySelector('.ty-card__atc[data-variant-id]');
      if (atcBtn && sizeBtn.dataset.variantId) {
        atcBtn.dataset.variantId = sizeBtn.dataset.variantId;
      }
      card.dataset.variantId = sizeBtn.dataset.variantId;
    }
  });

  // Sepete ekle — event delegation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ty-card__atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    // e.stopPropagation() kaldırıldı, çünkü iOS Safari'de touch-to-click dönüşümünü ve diğer event'leri bozabiliyor
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    addToCart(variantId, btn);
  });

  // CSS spin animasyonu (bir kez ekle)
  if (!document.getElementById('ty-atc-spin-style')) {
    var style = document.createElement('style');
    style.id = 'ty-atc-spin-style';
    style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }
})();
